import { AxiosResponse } from 'axios';
import { FnbItemGetDto, FnbOrderGetDto, FnbOrderGetWithItemsDto, ResultDto, QuantityGetDto } from 'svila-common';

import { API_URL } from '../../utils/constants';
import request from '../request';

export default {
  getOne: async (id: string): Promise<AxiosResponse<FnbOrderGetWithItemsDto>> => {
    return request(`${API_URL}/fnb/${id}`, 'get');
  },
  get: async (): Promise<AxiosResponse<FnbItemGetDto>> => {
    return request(`${API_URL}/fnb/no-match`, 'get');
  },
  updateSvilaGtins: async (fnbGtin: string, svilaGtin: string): Promise<AxiosResponse<FnbItemGetDto>> => {
    const body = {
      fnbGtin,
      svilaGtin,
    };
    return request(`${API_URL}/fnb/update-with-svila-gtin`, 'post', body);
  },
  updateFnbSvilaGtins: async (fnbId: string, svilaGtin: string): Promise<AxiosResponse<FnbItemGetDto>> => {
    const body = {
      fnbId,
      svilaGtin,
    };
    return request(`${API_URL}/fnb/update-fnb-svila-gtin`, 'post', body);
  },

  updateFnbOrder: async (fnbOrderId: string): Promise<AxiosResponse<FnbOrderGetDto>> => {
    return request(`${API_URL}/fnb/update-fnb-order/${fnbOrderId}`, 'post');
  },
  pullFnbOrders: async (): Promise<AxiosResponse<any>> => {
    return request(`${API_URL}/fnb/pull-fnb-orders`, 'get');
  },
  consolidate: async (): Promise<AxiosResponse<ResultDto>> => {
    return request(`${API_URL}/fnb/consolidate`, 'post');
  },
  getForConsolidation: async (id: string): Promise<AxiosResponse<any>> => {
    return request(`${API_URL}/fnb/get-for-consolidation/${id}`, 'get');
  },
  getInvoicesForConsolidation: async (id: string): Promise<AxiosResponse<FnbOrderGetWithItemsDto>> => {
    return request(`${API_URL}/fnb/fnb-customer-invoices-for-consolidation/${id}`, 'get');
  },
  getDiffsForConsolidation: async (id: string): Promise<AxiosResponse<FnbItemGetDto>> => {
    return request(`${API_URL}/fnb/get-differences-consolidation/${id}`, 'get');
  },
  getDiffsForFnbOrder: async (id: string): Promise<AxiosResponse<FnbItemGetDto>> => {
    return request(`${API_URL}/fnb/get-differences-fnb-order/${id}`, 'get');
  },
  togglePacked: async (id: string): Promise<AxiosResponse<void>> => {
    return request(`${API_URL}/fnb/toggle-packed/${id}`, 'post');
  },
  togglePendingDone: async (id: string): Promise<AxiosResponse<void>> => {
    return request(`${API_URL}/fnb/toggle-pending-done/${id}`, 'post');
  },
  resetFnb: async (id: string): Promise<AxiosResponse<ResultDto>> => {
    return request(`${API_URL}/fnb/reset-fnb/${id}`, 'post');
  },
  markAsSent: async (uniqueNumber: string): Promise<AxiosResponse<ResultDto>> => {
    return request(`${API_URL}/fnb/mark-as-sent/${uniqueNumber}`, 'put');
  },
  markAsComplete: async (uniqueNumber: string, skipInvoice: boolean): Promise<AxiosResponse<ResultDto>> => {
    return request(`${API_URL}/fnb/mark-as-completed/${uniqueNumber}${skipInvoice ? `/true` : `/false`}`, 'put');
  },
  testOrder: async (uniqueNumber: string): Promise<AxiosResponse<ResultDto>> => {
    return request(`${API_URL}/fnb/test-order/${uniqueNumber}`, 'get');
  },
  getHanging: async (): Promise<AxiosResponse<QuantityGetDto[]>> => {
    return request(`${API_URL}/fnb/get-hanging-order-quantities`, 'get');
  },
  getProblematicConsolidations: async (): Promise<AxiosResponse<ResultDto>> => {
    return request(`${API_URL}/fnb/get-problematic-consolidations`, 'get');
  },

  // get fnb orders from url get-for-consolidation, 'get' call returning FnbOrderGetWithItemsDto
  getFnbOrderForConsolidation: async (id: string): Promise<AxiosResponse<FnbOrderGetWithItemsDto>> => {
    return request(`${API_URL}/fnb/get-for-consolidation/${id}`, 'get');
  }

};
